import React from "react";
import { Card, Statistic, Empty, Col, Row } from "antd";
import { TotalSales } from "./TotalSales"; 
import { statusList } from "../../../../utils";

export const CardStatistic = ({
  data, 
  dateFilteredData, 
  totalSales, 
  dataOrders, 
  totalProducts, 
  averageSale, 
  percentage, 
  averageProductsPerOrder}) => {
  
  const totalShippingAmount = dataOrders?.reduce((acc,curr)=>acc+curr.shippingAmount,0);

  const deliveredOrders = dateFilteredData?.filter(
    (order) => order.status === "Entregado"
  );

  const deliveredSalesByDate = deliveredOrders?.map((order) => ({
    fecha: order.dateStart.toDate().toLocaleDateString(),
    total: order.saleAmount,
    shipping: order.shippingAmount ? order.shippingAmount : 0
  }));

  const deliveredSalesByDateGrouped = deliveredSalesByDate?.reduce(
    (acc, curr) => {
      const existing = acc?.find((item) => item.fecha === curr.fecha);
      if (existing) {
        existing.total += curr.total;
        existing.cantidad++;
        existing.shipping += curr.shipping;
      } else {
        acc.push({ ...curr, cantidad: 1 });
      }
      return acc;
    },
    []
  );

  deliveredSalesByDateGrouped?.sort(
    (a, b) => new Date(a.fecha) - new Date(b.fecha)
  );

  const deliveredSales = deliveredSalesByDateGrouped?.reduce(
    (acc, item) => acc + item.total,
    0
  );

  const percentageDeliveredSales =
    deliveredSales !== 0 ? (deliveredSales / totalSales) * 100 : 0;

  const deliveredProducts = deliveredOrders?.reduce(
    (accumulator, current) =>
      accumulator +
      current.products?.reduce((total, item) => total + item.quantity, 0),
    0
  );

  const averageDeliveredSale = (deliveredSales / deliveredProducts);

  const averageDeliveredProductsPerOrder =
    deliveredOrders?.length > 0 ? (deliveredProducts / deliveredOrders?.length) : 0;
  
  const totalShippingAmountDeliveredOrders = deliveredSalesByDateGrouped?.reduce(
    (acc, item) => acc + item.shipping, 0
  );

  const pendingOrders = dateFilteredData?.filter(
    (order) => order.status === "Pendiente"
  );

  const pendingSalesByDate = pendingOrders?.map((order) => ({
    fecha: order.dateStart.toDate().toLocaleDateString(),
    total: order.saleAmount,
    shipping: order.shippingAmount ? order.shippingAmount : 0
  }));

  const pendingSalesByDateGrouped = pendingSalesByDate?.reduce(
    (acc, curr) => {
      const existing = acc?.find((item) => item.fecha === curr.fecha);
      if (existing) {
        existing.total += curr.total;
        existing.cantidad++;
        existing.shipping += curr.shipping;
      } else {
        acc.push({ ...curr, cantidad: 1 });
      }
      return acc;
    },
    []
  );

  pendingSalesByDateGrouped?.sort(
    (a, b) => new Date(a.fecha) - new Date(b.fecha)
  );

  const pendingSales = pendingSalesByDateGrouped?.reduce(
    (acc, item) => acc + item.total,
    0
  );

  const percentagePendingSales =
    pendingSales !== 0 ? (pendingSales / totalSales) * 100 : 0;

  const pendingProducts = pendingOrders?.reduce(
    (accumulator, current) =>
      accumulator +
      current.products?.reduce((total, item) => total + item.quantity, 0),
    0
  );

  const averagePendingSale = (pendingSales / pendingProducts);

  const averagePendingProductsPerOrder =
    pendingOrders?.length > 0 ? (pendingProducts / pendingOrders?.length) : 0;

  const totalShippingAmountPendingOrders = pendingSalesByDateGrouped?.reduce(
    (acc, item) => acc + item.shipping,
      0
  );

  const manageOrders = dateFilteredData?.filter(
    (order) => order.status === "Pendiente de stock" || order.status === "No hay stock" 
  );

  const manageSalesByDate = manageOrders?.map((order) => ({
    fecha: order.dateStart.toDate().toLocaleDateString(),
    total: order.saleAmount,
    shipping: order.shippingAmount ? order.shippingAmount : 0
  }));

  const manageSalesByDateGrouped = manageSalesByDate?.reduce(
    (acc, curr) => {
      const existing = acc?.find((item) => item.fecha === curr.fecha);
      if (existing) {
        existing.total += curr.total;
        existing.cantidad++;
        existing.shipping += curr.shipping;
      } else {
        acc.push({ ...curr, cantidad: 1 });
      }
      return acc;
    },
    []
  );

  manageSalesByDateGrouped?.sort(
    (a, b) => new Date(a.fecha) - new Date(b.fecha)
  );

  const manageSales = manageSalesByDateGrouped?.reduce(
    (acc, item) => acc + item.total,
    0
  );

  const percentageManageSales =
    manageSales !== 0 ? (manageSales / totalSales) * 100 : 0;

  const manageProducts = manageOrders?.reduce(
    (accumulator, current) =>
      accumulator +
      current.products?.reduce((total, item) => total + item.quantity, 0),
    0
  );

  const averageManageSale = (manageSales / manageProducts);

  const averageManageProductsPerOrder =
    manageOrders?.length > 0 ? (manageProducts / manageOrders?.length) : 0;

  const totalShippingAmountManageOrders = manageSalesByDateGrouped?.reduce(
    (acc, item) => acc + item.shipping,
      0
  );

  const lostOrders = dateFilteredData?.filter(
    (order) => order.status === "Cancelado" || order.status === "Fallido" 
  );

  const lostSalesByDate = lostOrders?.map((order) => ({
    fecha: order.dateStart.toDate().toLocaleDateString(),
    total: order.saleAmount,
    shipping: order.shippingAmount ? order.shippingAmount : 0
  }));

  const lostSalesByDateGrouped = lostSalesByDate?.reduce(
    (acc, curr) => {
      const existing = acc?.find((item) => item.fecha === curr.fecha);
      if (existing) {
        existing.total += curr.total;
        existing.cantidad++;
        existing.shipping += curr.shipping;
      } else {
        acc.push({ ...curr, cantidad: 1 });
      }
      return acc;
    },
    []
  );

  lostSalesByDateGrouped?.sort(
    (a, b) => new Date(a.fecha) - new Date(b.fecha)
  );

  const lostSales = lostSalesByDateGrouped?.reduce(
    (acc, item) => acc + item.total,
    0
  );

  const percentageLostSales =
    lostSales !== 0 ? (lostSales / totalSales) * 100 : 0;

  const lostProducts = lostOrders?.reduce(
    (accumulator, current) =>
      accumulator +
      current.products?.reduce((total, item) => total + item.quantity, 0),
    0
  );

  const averageLostSale = (lostSales / lostProducts);

  const averageLostProductsPerOrder =
    lostOrders?.length > 0 ? (lostProducts / lostOrders?.length) : 0;

  const totalShippingAmountLostOrders = lostSalesByDateGrouped?.reduce(
    (acc, item) => acc + item.shipping,
      0
  );

  const cardInfo = [
    {
      title: "Ventas totales",
      value: totalSales > 0 ? `S/ ${Math.round((totalSales + Number.EPSILON)*100)/100}` : ' - ',
      color: statusList["No hay stock"].color,
    },
    {
      title: "Órdenes totales",
      value: dataOrders?.length > 0 ? dataOrders?.length : ' - ',
      color: statusList["No hay stock"].color,
    },
    {
      title: "Productos totales",
      value: totalProducts > 0 ? totalProducts : ' - ',
      color: statusList["No hay stock"].color,
    },
    {
      title: "Promedio venta/prod",
      value: averageSale > 0 ? `S/ ${averageSale}` : ' - ',
      color: statusList["No hay stock"].color,
    },
    {
      title: "Porcentaje del total",
      value: percentage > 0 ? percentage : ' - ',
      suffix: percentage > 0 ? "%" : null,
      color: statusList["No hay stock"].color,
    },
    {
      title: "Ticket promedio",
      value: averageProductsPerOrder > 0 ? averageProductsPerOrder : ' - ',
      color: statusList["No hay stock"].color,
    },
    {
      title: "Monto de envio pedidos",
      value: totalShippingAmount > 0 ? `S/ ${Math.round((totalShippingAmount + Number.EPSILON)*100)/100}` : ' - ',
      color: statusList["No hay stock"].color,
    },
    {
      title: "Ventas entregadas",
      value: deliveredSales > 0 ? `S/ ${Math.round((deliveredSales + Number.EPSILON)*100)/100}` : ' - ',
      color: statusList.Entregado.color,
    },
    {
      title: "Órdenes entregadas",
      value: deliveredOrders?.length > 0 ? deliveredOrders?.length : ' - ',
      color: statusList.Entregado.color,
    },
    {
      title: "Productos entregados",
      value: deliveredProducts > 0 ? deliveredProducts : ' - ',
      color: statusList.Entregado.color,
    },
    {
      title: "Promedio venta/prod. entregado",
      value: averageDeliveredSale > 0 ? `S/ ${Math.round((averageDeliveredSale + Number.EPSILON)*100)/100}` : ' - ',
      color: statusList.Entregado.color,
    },
    {
      title: "Porcentaje entregadas",
      value: percentageDeliveredSales > 0 ? Math.round((percentageDeliveredSales + Number.EPSILON)*100)/100 : ' - ',
      suffix: percentageDeliveredSales > 0 ? "%" : null,
      color: statusList.Entregado.color,
    },
    {
      title: "Ticket entregado promedio",
      value: averageDeliveredProductsPerOrder > 0 ? Math.round((averageDeliveredProductsPerOrder + Number.EPSILON)*100)/100 : ' - ',
      color: statusList.Entregado.color,
    },
    {
      title: "Monto de envio pedidos entregados",
      value: totalShippingAmountDeliveredOrders > 0 ? `S/ ${Math.round((totalShippingAmountDeliveredOrders + Number.EPSILON)*100)/100}` : ' - ',
      color: statusList.Entregado.color,
    },
    {
      title: "Ventas por procesar",
      value: pendingSales > 0 ? `S/ ${Math.round((pendingSales + Number.EPSILON)*100)/100}` : ' - ',
      color: statusList.Agendado.color,
    },
    {
      title: "Órdenes por procesar",
      value: pendingOrders?.length > 0 ? pendingOrders?.length : ' - ',
      color: statusList.Agendado.color,
    },
    {
      title: "Productos por procesar",
      value: pendingProducts > 0 ? pendingProducts : ' - ',
      color: statusList.Agendado.color,
    },
    {
      title: "Promedio venta/prod por procesar",
      value: averagePendingSale > 0 ? `S/ ${Math.round((averagePendingSale + Number.EPSILON)*100)/100}` : ' - ',
      color: statusList.Agendado.color,
    },
    {
      title: "Porcentaje por procesar",
      value: percentagePendingSales > 0 ? Math.round((percentagePendingSales + Number.EPSILON)*100)/100 : ' - ',
      suffix: percentagePendingSales > 0 ? "%" : null,
      color: statusList.Agendado.color,
    },
    {
      title: "Ticket por procesar promedio",
      value: averagePendingProductsPerOrder > 0 ? Math.round((averagePendingProductsPerOrder + Number.EPSILON)*100)/100 : ' - ',
      color: statusList.Agendado.color,
    },
    {
      title: "Monto de envio pedidos por procesar",
      value: totalShippingAmountPendingOrders > 0 ? `S/ ${Math.round((totalShippingAmountPendingOrders + Number.EPSILON)*100)/100}` : ' - ',
      color: statusList.Agendado.color,
    },
    {
      title: "Ventas por gestionar",
      value: manageSales > 0 ? `S/ ${Math.round((manageSales + Number.EPSILON)*100)/100}` : ' - ',
      color: statusList["Pendiente de stock"].color,
    },
    {
      title: "Órdenes por gestionar",
      value: manageOrders?.length > 0 ? manageOrders?.length : ' - ',
      color: statusList["Pendiente de stock"].color,
    },
    {
      title: "Productos por gestionar",
      value: manageProducts > 0 ? manageProducts : ' - ',
      color: statusList["Pendiente de stock"].color,
    },
    {
      title: "Promedio venta/prod por gestionar",
      value: averageManageSale > 0 ? `S/ ${Math.round((averageManageSale + Number.EPSILON)*100)/100}` : ' - ',
      color: statusList["Pendiente de stock"].color,
    },
    {
      title: "Porcentaje por gestionar",
      value: percentageManageSales > 0 ? Math.round((percentageManageSales + Number.EPSILON)*100)/100 : ' - ',
      suffix: percentageManageSales > 0 ? "%" : null,
      color: statusList["Pendiente de stock"].color,
    },
    {
      title: "Ticket por gestionar promedio",
      value: averageManageProductsPerOrder > 0 ? Math.round((averageManageProductsPerOrder + Number.EPSILON)*100)/100 : ' - ',
      color: statusList["Pendiente de stock"].color,
    },
    {
      title: "Monto de envio pedidos por gestionar",
      value: totalShippingAmountManageOrders > 0 ? `S/ ${Math.round((totalShippingAmountManageOrders + Number.EPSILON)*100)/100}` : ' - ',
      color: statusList["Pendiente de stock"].color,
    },
    {
      title: "Ventas perdidas",
      value: lostSales > 0 ? `S/ ${Math.round((lostSales + Number.EPSILON)*100)/100}` : ' - ',
      color: statusList.Cancelado.color,
    },
    {
      title: "Órdenes perdidas",
      value: lostOrders?.length > 0 ? lostOrders?.length : ' - ',
      color: statusList.Cancelado.color,
    },
    {
      title: "Productos perdidos",
      value: lostProducts > 0 ? lostProducts : ' - ',
      color: statusList.Cancelado.color,
    },
    {
      title: "Promedio venta/prod perdido",
      value: averageLostSale > 0 ? `S/ ${Math.round((averageLostSale + Number.EPSILON)*100)/100}` : ' - ',
      color: statusList.Cancelado.color,
    },
    {
      title: "Porcentaje perdidos",
      value: percentageLostSales > 0 ? Math.round((percentageLostSales + Number.EPSILON)*100)/100 : ' - ',
      suffix: percentageLostSales > 0 ? "%" : null,
      color: statusList.Cancelado.color,
    },
    {
      title: "Ticket perdido promedio",
      value: averageLostProductsPerOrder > 0 ? Math.round((averageLostProductsPerOrder + Number.EPSILON)*100)/100 : ' - ',
      color: statusList.Cancelado.color,
    },
    {
      title: "Monto de envio pedidos perdidos",
      value: totalShippingAmountLostOrders > 0 ? `S/ ${Math.round((totalShippingAmountLostOrders + Number.EPSILON)*100)/100}` : ' - ',
      color: statusList.Cancelado.color,
    },
  ];

  return (
    <div className="py-4 mx-auto">
      <div className="flex flex-wrap justify-center mx-auto">
      <Row gutter={[16, 16]} wrap={true} className="flex flex-wrap justify-center min-w-fit">
        {cardInfo.map((card, index) => (
          <Col key={index}>
           <Card bordered={true} className="text-center mb-4 w-96 lg:w-60" style={{"backgroundColor":`${card.color}`}}>
              <Statistic
               className="text-sm"
                title={card.title}
                value={card.value}
                suffix={card.suffix}
              />
            </Card>
           </Col>
         ))}
        </Row>
        <div className="w-full">
          {data?.length > 0 || dateFilteredData > 0 ? (
            <TotalSales data={dataOrders} dateFilter={dateFilteredData} />
          ) : (
            <Card title="Resumen" className="w-full">
              <div className="h-36 flex justify-center items-center">
                <Empty description="No hay datos disponibles" />
              </div>
            </Card>
          )}
        </div>
      </div>
    </div>
  );
};
